import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Calendar, Phone, ArrowRight } from "lucide-react";

const Pickup = () => {
  return (
    <div data-testid="pickup-page" className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
      <div className="text-brand font-display text-sm tracking-[0.4em] mb-2">/ PICKUP</div>
      <h1 className="font-display text-6xl sm:text-7xl text-cream leading-none mb-12">GOSFORD SHOWGROUNDS.</h1>

      <div className="grid md:grid-cols-2 gap-6">
        {[
          { icon: <MapPin className="text-brand" size={26} />, t: "WHERE", body: "Gosford Showgrounds, Showground Road, Gosford NSW. Look for the smoke." },
          { icon: <Calendar className="text-brand" size={26} />, t: "WHEN", body: "Saturday & Sunday. Pre-order anytime, pick a slot at checkout." },
          { icon: <Clock className="text-brand" size={26} />, t: "HOURS", body: "11:00am – 5:00pm. 30-min slots. Be on time — hot food waits for no one." },
          { icon: <Phone className="text-brand" size={26} />, t: "QUESTIONS", body: "DM @blazingedgebbq or email hello@blazingedge.bbq." },
        ].map((c) => (
          <div key={c.t} className="border border-ink-600 bg-ink-800 p-7">
            {c.icon}
            <div className="font-display text-2xl text-cream mt-3 tracking-widest">{c.t}</div>
            <p className="text-[#C8C4BB] mt-2 leading-relaxed">{c.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 text-center">
        <Link to="/shop" className="inline-flex items-center gap-2 px-10 h-14 bg-brand hover:bg-brand-hover text-ink-900 font-display text-2xl tracking-widest teal-glow-hover transition-all">
          START YOUR ORDER <ArrowRight size={20} strokeWidth={3} />
        </Link>
      </div>
    </div>
  );
};

export default Pickup;
